/* eslint-disable max-classes-per-file */
export class MCountry {
    code: string

    id: string

    name: string

    parentId: string

    type: string

    value?: string

    constructor(value: MCountry) {
        this.code = value?.code
        this.id = value?.id
        this.name = value?.name
        this.parentId = value?.parentId
        this.type = value?.type
        this.value = value?.code
    }
}

export class MState extends MCountry {}
export class MCity extends MCountry {}

export class MPOB {
    countries: MCountry[]

    states: MState[]

    cities: MCity[]

    constructor(POB: MPOB) {
        this.countries = POB?.countries
        this.states = POB?.states
        this.cities = POB?.cities
    }
}

export class MPR extends MPOB {}

export class MProfile {
    address: string

    city: string

    country: string

    dob: string

    firstName: string

    gender: string

    height: string

    lastName: string

    middleName: string

    profileImage: string

    state: string

    weight: string

    zipCode: string

    constructor(profile: MProfile) {
        this.address = profile?.address
        this.city = profile?.city
        this.country = profile?.country
        this.dob = profile?.dob
        this.firstName = profile?.firstName
        this.gender = profile?.gender
        this.height = profile?.height
        this.lastName = profile?.lastName
        this.middleName = profile?.middleName
        this.profileImage = profile?.profileImage
        this.state = profile?.state
        this.weight = profile?.weight
        this.zipCode = profile?.zipCode
    }
}

export class MRole {
    code: string

    createdAt: string

    createdBy: string

    description: string

    id: string

    name: string

    sequence: number

    status: string

    type: string

    updatedAt: string

    updatedBy: string

    constructor(role: MRole) {
        this.code = role?.code
        this.createdAt = role?.createdAt
        this.createdBy = role?.createdBy
        this.description = role?.description
        this.id = role?.id
        this.name = role?.name
        this.sequence = role?.sequence
        this.status = role?.status
        this.type = role?.type
        this.updatedAt = role?.updatedAt
        this.updatedBy = role?.updatedBy
    }
}

export class MUser {
    createdAt: string

    deletedAt: string

    deletedBy: string

    email: string

    id: string

    isAllowLogin: number | boolean

    lastChangedPasswordAt: string

    permissions: string[]

    phone: string

    positionId: string

    profile: MProfile

    address: string

    city: string

    country: string

    dob: string

    firstName: string

    gender: string

    height: string

    lastName: string

    middleName: string

    profileImage: string

    state: string

    weight: string

    zipCode: string

    role: MRole

    securityNumber: string

    status: string

    updatedAt: string

    username: string

    constructor(user: MUser) {
        this.createdAt = user?.createdAt
        this.deletedAt = user?.deletedAt
        this.deletedBy = user?.deletedBy
        this.email = user?.email
        this.id = user?.address
        this.isAllowLogin = user?.isAllowLogin
        this.lastChangedPasswordAt = user?.lastChangedPasswordAt
        this.permissions = user?.permissions
        this.phone = user?.phone
        this.positionId = user?.positionId
        this.profile = user?.profile
        this.address = user?.address
        this.city = user?.city
        this.country = user?.country
        this.dob = user?.dob
        this.firstName = user?.firstName
        this.gender = user?.gender
        this.height = user?.height
        this.lastName = user?.lastName
        this.middleName = user?.middleName
        this.profileImage = user?.profileImage
        this.state = user?.state
        this.weight = user?.weight
        this.zipCode = user?.zipCode
        this.role = user?.role
        this.securityNumber = user?.securityNumber
        this.status = user?.status
        this.updatedAt = user?.updatedAt
        this.username = user?.username
    }
}

export class MAuth {
    authToken: string

    register: any

    user: any

    accessToken: string

    publicToken: string

    isLoading: boolean

    countries: MCountry[]

    states: MState[]

    cities: MCity[]

    POB: MPOB

    PR: MPR

    dynamicReground: any

    constructor(value: MAuth) {
        this.authToken = value?.authToken
        this.accessToken = value?.accessToken
        this.register = value?.register
        this.user = value?.user
        this.publicToken = value?.publicToken
        this.isLoading = value?.isLoading
        this.countries = value?.countries
        this.states = value?.states
        this.cities = value?.cities
        this.POB = value?.POB
        this.PR = value?.PR
        this.dynamicReground = value?.dynamicReground
    }
}

// reground
export type RegroundTypes = 'COUNTRY' | 'STATE' | 'CITY'
